import { AuthError, defineEntity } from '@juvare/platform-app/App';
import { accountTrainCourseSchema, columns } from './types';
export const accountTrainCourseEntityName = 'accountTrainCourse';
export function createAccountTrainCourseEntity() {
    return defineEntity({
        version: 1,
        columns,
        onTransformColumns: (_, params) => {
            return params.data;
        },
        onMigrate: (params) => {
            return params.oldData;
        },
        onAuthPost: () => {
            // no direct post is allowed, because entity is updated internally -
            // background task
            throw new AuthError('Unauthorized');
        },
        onAuthGet: () => {
            // no direct get is allowed, because entity is used internally -
            // platform function, view, background task
            throw new AuthError('Unauthorized');
        },
        onAuthList: () => {
            // no direct get is allowed, because entity is used internally -
            // platform function, view, background task
            throw new AuthError('Unauthorized');
        },
    }, accountTrainCourseSchema);
}
